import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { createDispatchers } from "@utils/dispatcher";
import { RootState } from "..";

export type SnackbarSeverity = "success" | "error" | "warning" | "info";

export interface SnackbarAction {
  label: string;
  dashboardName?: string;
  onClick: () => void;
}

export interface ISnackbarState {
  open: boolean;
  message: string;
  severity: SnackbarSeverity;
  autoHideDuration: number;
  action?: SnackbarAction;
}

export const initialState: ISnackbarState = {
  open: false,
  message: "",
  severity: "info",
  autoHideDuration: 6000,
  action: undefined,
};

export const snackbarSlice = createSlice({
  name: "snackbar",
  initialState,
  reducers: {
    showSnackbar: (
      state,
      action: PayloadAction<{
        message: string;
        severity?: SnackbarSeverity;
        autoHideDuration?: number;
      }>,
    ) => {
      state.open = true;
      state.message = action.payload.message;
      state.severity = action.payload.severity || "info";
      state.autoHideDuration = action.payload.autoHideDuration || 6000;
    },
    hideSnackbar: (state) => {
      state.open = false;
    },
    showErrorSnackbar: (
      state,
      action: PayloadAction<{
        message: string;
        autoHideDuration?: number;
        action?: SnackbarAction;
      }>,
    ) => {
      state.open = true;
      state.message = action.payload.message;
      state.severity = "error";
      state.autoHideDuration = action.payload.autoHideDuration || 6000;
      state.action = action.payload.action;
    },
    showSuccessSnackbar: (
      state,
      action: PayloadAction<{
        message: string;
        autoHideDuration?: number;
        action?: SnackbarAction;
      }>,
    ) => {
      state.open = true;
      state.message = action.payload.message;
      state.severity = "success";
      state.autoHideDuration = action.payload.autoHideDuration || 6000;
      state.action = action.payload.action;
    },
  },
});

export const {
  showSnackbar,
  hideSnackbar,
  showErrorSnackbar,
  showSuccessSnackbar,
} = snackbarSlice.actions;

export const snackbarDispatcher = createDispatchers(snackbarSlice.actions);
export const snackbarSelector = (state: RootState) => state.snackbar;

export const snackbarReducer = snackbarSlice.reducer;
